import React, { useState, useEffect } from "react";
import axios from 'axios';
import AWS from 'aws-sdk';
import { notification } from 'antd';
import AudioPlayer from '../AudioPlayer';

const Card = () => {
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedOption, setSelectedOption] = useState('option2');
    const [dropDown, setDropDown] = useState(false);
    const [audioUrl, setAudioUrl] = useState('');
    const [audioUrlload, setaudioUrlload] = useState(false);
    const [currentLectureName, setCurrentLectureName] = useState('');
    const [search, setSearch] = useState("");
    const [activeLectureUrl, setActiveLectureUrl] = useState('');
    const [currentParts, setCurrentParts] = useState([]);
    const [currentPartIndex, setCurrentPartIndex] = useState(-1);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.post('/api/getLecture', { type: "Sahi Bukhari Class" });
                setData(response.data.reverse());
                setIsLoading(false);
            } catch (error) {
                setError(error);
                setIsLoading(false);
            }
        };
        fetchData();
    }, []);

    const handleSearchChange = (event) => {
        setSearch(event.target.value);
    };

    const filteredData = data ? data.filter(item =>
        item.name.toLowerCase().includes(search.toLowerCase())
    ) : [];

    const handleOptionChange = (event) => {
        setData(data.reverse());
        setSelectedOption(event.target.value);
        console.log(event.target.value);
    };

    const DropDownFunc = () => {
        setDropDown(!dropDown);
    };

    const handleLinkClick = (url, lectureName, originalUrl, parts, partIndex) => {
        setaudioUrlload(false);
        if (originalUrl) setActiveLectureUrl(originalUrl);
        else setActiveLectureUrl('');
        setCurrentParts(parts || []);
        setCurrentPartIndex(partIndex !== undefined ? partIndex : -1);
        const regex = /id=([^&]+)/;
        const idMatch = url.match(regex);
        console.log(idMatch);
        if (idMatch) {
            const id = idMatch[1];
            const s3 = new AWS.S3({
                endpoint: 's3.wasabisys.com',
                accessKeyId: 'I8ITVDL3GT2TQA0ZFSAB',
                secretAccessKey: 'DszVpDdzqP1si8PUybJQ3ae3784AJ1vTSN2sqRTq',
                region: 'us-east-1'
            });
            const params = {
                Bucket: 'sakeenat',
                Key: `${id}.mp4`,
                Expires: 60
            };
            s3.getSignedUrl('getObject', params, (err, url) => {
                if (err) {
                    notification.error({ message: "Unable to open this lecture" });
                    console.log('error', err);
                } else {
                    setAudioUrl(url);
                    setCurrentLectureName(lectureName);
                    setaudioUrlload(true);
                }
            });
        }
    };

    function removeSpecificPhrase(inputString, phraseToRemove) {
        return inputString.replace(new RegExp(phraseToRemove, 'g'), '');
    }

    if (isLoading) {
        return (
            <div className="al-container">
                <div className="al-loading"><div className="al-spinner" />Loading lectures...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="al-container">
                <div className="al-error">Failed to load lectures. Please try again.</div>
            </div>
        );
    }

    return (
        <div className="al-container">
            {/* Legacy recordings dropdown */}
            <button className="al-legacy-toggle" onClick={DropDownFunc}>
                {dropDown ? 'Hide' : 'Show'} Legacy Lectures #1 - #23
            </button>
            {dropDown && (
                <div className="al-legacy-list">
                    <li>SAHIBUKHARI 0001 - Class 1 by Alima Nikhat Haider Aapa | Date: Tuesday, September 3, 2019 | Topic: "LIFE OF IMAM ABU BUKHARI R.A"</li>
                    <li>SAHIBUKHARI - Class 2 by Alima Nikhat Haider Aapa | Part 2 of "Life of Imam Bukhari"</li>
                    <li>Recordings - Sahi Bukhari Class 3 by Alima Nikhat Haider Aapa | Topic: "Ilm e Hadees"</li>
                    <li>SAHIBUKHARI - Class 004 SB by Alima Nikhat Haider Aapa | Date: Tuesday, October 8, 2019 | Topic: "KITABUL UL WAHI" (Hadith #1)</li>
                    <li>SAHIBUKHARI - Class 005 SB by Alima Nikhat Haider Aapa | Date: Tuesday, October 22, 2019 | Topic: "KITABUL UL WAHI" (Hadith #2 &amp; 3)</li>
                    <li>SAHIBUKHARI - Class 0006 SB by Alima Nikhat Haider Aapa | Date: Tuesday, October 29, 2019 | Topic: "KITABUL UL WAHI" (Hadith #4 &amp; 5)</li>
                    <li>SAHIBUKHARI - Class 0006 SB by Alima Nikhat Haider Aapa | Date: Tuesday, November 5, 2019 | Topic: "KITABUL UL WAHI" (Hadith #6 &amp; 7)</li>
                    <li>SAHIBUKHARI - Class 0008 SB by Alima Nikhat Haider Aapa | Date: Tuesday, November 12, 2019 | Topic: "KITABUL UL WAHI"</li>
                    <li>SAHIBUKHARI - Class 0009 SB by Alima Nikhat Haider Aapa | Date: Tuesday, November 19, 2019 | Topic: "KITABUL UL IMAAN"</li>
                    <li>Recording - SAHIBUKHARI Class 0010 SB by Alima Nikhat Haider Aapa | Date: Tuesday, December 3, 2019 | Topic: Hadith #9 &amp; 10</li>
                    <li>Recording - SAHIBUKHARI Class 0011 SB by Alima Nikhat Haider Aapa | Date: Tuesday, December 10, 2019 | Topic: Hadith #12, 13, 14, 15</li>
                    <li>Recording - SAHIBUKHARI Class 0012 SB by Alima Nikhat Haider Aapa | Date: Tuesday, January 7, 2020 | Topic: Hadith #14, 15, 16</li>
                    <li>Recording - SAHIBUKHARI Class 0013 SB by Aalimah Nikhat Haider Aapa | Date: Tuesday, January 14, 2020 | Topic: "HALAWAT UL INAN" | Hadith: #17, 18</li>
                    <li>Recording - SAHIBUKHARI Class 0013 SB by Aalimah Nikhat Haider Aapa | Date: Tuesday, January 21, 2020 | Topic: "HALAWAT UL INAN" | Hadith: #19, 20, 21, 22</li>
                    <li>Recording - SAHIBUKHARI Class 0015 SB by Aalimah Nikhat Haider Aapa | Date: Tuesday, January 28, 2020 | Topic: "HALAWAT UL INAN" | Hadith: #23, 24, 25</li>
                    <li>Recording - SAHIBUKHARI Class 0016 SB by Aalimah Nikhat Haider Aapa | Date: Tuesday, February 4, 2020 | Topic: "HALAWAT UL INAN" | Hadith: #26, 27, 28</li>
                    <li>Recording - SAHIBUKHARI Class 0017 SB by Aalimah Nikhat Haider Aapa | Date: Tuesday, February 11, 2020 | Topic: "HALAWAT UL INAN" | Hadith: #29, 30, 31</li>
                    <li>Recording - SAHIBUKHARI Class 0018 SB by Aalimah Nikhat Haider Aapa | Date: Tuesday, February 18, 2020 | Topic: "HALAWAT UL INAN" | Hadith: #32, 33, 34, 35, 36</li>
                    <li>Recording - SAHIBUKHARI Class 0019 SB by Aalimah Nikhat Haider Aapa | Date: Tuesday, February 25, 2020 | Topic: "HALAWAT UL INAN" | Hadith: #37, 38, 39, 40</li>
                    <li>Recording - SAHIBUKHARI Class 0020 SB by Aalimah Nikhat Haider Aapa | Date: Tuesday, March 3, 2020 | Topic: "HALAWAT UL INAN" | Hadith: #41, 42, 43, 44, 45</li>
                    <li>Recording - SAHIBUKHARI Class 0021 SB by Aalimah Nikhat Haider Aapa | Date: Tuesday, March 10, 2020 | Topic: "HALAWAT UL INAN" | Hadith: #46, 47, 48, 49</li>
                    <li>Recording - SAHIBUKHARI Class 0022 SB by Aalimah Nikhat Haider Aapa | Date: Tuesday, March 17, 2020 | Topic: "HALAWAT UL INAN" | Hadith: #50, 51, 52</li>
                    <li>Recording - SAHIBUKHARI Class 0023 SB by Aalimah Nikhat Haider Aapa | Date: Tuesday, March 23, 2020 | Topic: "HALAWAT UL INAN" | Hadith: #53, 54, 55, 56, 57, and 58</li>
                    <div className="al-legacy-links">
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=1DqzQMVBqT1tkXBlBOpZF26DhsGD2I9wD&export=download", "Legacy Lecture 2")}>Lec 2</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=1PKJ8_6fNz7ETFYj6r6ayIxU6E64GhxNO&export=download", "Legacy Lecture 3")}>Lec 3</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=1d9aQvsAZlrpxKwboFJNKkiY5II6qVoJB&export=download", "Legacy Lecture 4")}>Lec 4</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=1w8FlxmpbYRNkgcwP9glBfoAhQ0TkNVqZ&export=download", "Legacy Lecture 5")}>Lec 5</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=1GknbjrSnpOMZZOTAbK1aDyjU_wEfeD6w&export=download", "Legacy Lecture 6")}>Lec 6</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=1z2nPIuCviZcCq7br_N0naxZawnRw_dSd&export=download", "Legacy Lecture 7")}>Lec 7</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=1Q9bsAgJ6OKymKGgOVEm5oFJm7mHi8Poh&export=download", "Legacy Lecture 8")}>Lec 8</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=1ie8DSQVkSXULpeWhmV943wD3LDjnmJdV&export=download", "Legacy Lecture 9")}>Lec 9</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=1lyuNCijxJ15IfgJreoEpfxLjdywbIjkZ&export=download", "Legacy Lecture 10")}>Lec 10</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=1V9vvu2BbYSZc3wGOyzlmMklI7vCZQhs_&export=download", "Legacy Lecture 11")}>Lec 11</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=1oT9KACFo78oJ57DzdIJVdscXBgVd93cX&export=download", "Legacy Lecture 12")}>Lec 12</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=1b0mSSWF-4GKki5Y5Z_DlKpnSTmUSJjAJ&export=download", "Legacy Lecture 13")}>Lec 13</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=1ubTTGRv5Kkf1rOANb8r6oi_CIObJDThQ&export=download", "Legacy Lecture 14")}>Lec 14</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=1Wh74Z5VO0s8r73FDOQqeQJ0AnRpPRr33&export=download", "Legacy Lecture 15")}>Lec 15</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=14scBT3de54MUi2inPDbFLHQ9ART27LS2&export=download", "Legacy Lecture 16")}>Lec 16</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=10ND_IZx0Jq5L46t-4diXIL4CUgrmUvVg&export=download", "Legacy Lecture 17")}>Lec 17</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=1kK0BVnD9uQyKt38KvnOEgxymr0rzOGZT&export=download", "Legacy Lecture 18")}>Lec 18</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=1Sr8kzktwVkFZMDAbUoiu3uT7BhytpjGR&export=download", "Legacy Lecture 19")}>Lec 19</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=12FJ8RLW39sN3Gk3eO8-gixsEwYKZk6MW&export=download", "Legacy Lecture 20")}>Lec 20</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=1z7zBjJwARSTLlGvdgu7G9kl4m4zpi6KJ&export=download", "Legacy Lecture 21")}>Lec 21</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=1XEoVPbkis6L46kqeYyY5JnxPXgJUnI1k&export=download", "Legacy Lecture 22")}>Lec 22</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=1739k8OiPQH7qg5w5yjtPVPOO1MbBg7fQ&export=download", "Legacy Lecture 23")}>Lec 23</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=1VIdxwBIITpJ2hUKdbYYpbAheJpJI0X5D&export=download", "Legacy Lecture 24")}>Lec 24</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=1gJPUdzqVAX7QSDNLhIZlDxme9dMtLjcn&export=download", "Legacy Lecture 25")}>Lec 25</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=1aBfJwuyzuzfeMkQAk0kMS1JXFkQZhgxt&export=download", "Legacy Lecture 26")}>Lec 26</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=11xuV3YSS6xgCPNhX4w7KTNiV26St4_R5&export=download", "Legacy Lecture 27")}>Lec 27</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=1dm1OF0bDxuuyHKgB8JH4UYIbjwWBYpF3&export=download", "Legacy Lecture 28")}>Lec 28</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=1itU0E4e9JLQEpokO-UFFJYBk7Bj9K3pP&export=download", "Legacy Lecture 29")}>Lec 29</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=1MMO-pxKONmwevilt8_vNB6hxo1-I2i40&export=download", "Legacy Lecture 30")}>Lec 30</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=1IfFm5PE9pBbQbAnFLPEXY6hHOFF0sL99&export=download", "Legacy Lecture 31")}>Lec 31</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=1SGrlV4ATmtOgW4MR_PxUzXen4oR7q3w2&export=download", "Legacy Lecture 32")}>Lec 32</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=12GJFA9_-mJzMdiALKyoh-NmSPxfDsylO&export=download", "Legacy Lecture 33")}>Lec 33</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=1G5yfdN7YNbGnjo-H6STEQwCMdJE8XiO_&export=download", "Legacy Lecture 34")}>Lec 34</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=16gyo2vNiVh-fk137HVNJL6G5Nck3C-Y_&export=download", "Legacy Lecture 35")}>Lec 35</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=1ROhCmYqhPoVzRkS3qrIgJFL2-_8qMEFx&export=download", "Legacy Lecture 36")}>Lec 36</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=12DXB_M0t0DbSa_Bol05nyn_YpTYJv4RV&export=download", "Legacy Lecture 37")}>Lec 37</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=1-1Owse5DiueXlE-8jVnHslETb-OVQlSN&export=download", "Legacy Lecture 38")}>Lec 38</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=1YJQTZ2113pPlRShIDzVpDlzNLuyB0j6A&export=download", "Legacy Lecture 39")}>Lec 39</button>
                        <button className="al-play-chip" onClick={() => handleLinkClick("https://drive.usercontent.google.com/u/2/uc?id=1rrwhPcosVW4Xt8ct5mRy8jNeDNgRxy2D&export=download", "Legacy Lecture 40")}>Lec 40</button>
                    </div>
                </div>
            )}

            {/* Toolbar */}
            <div className="al-toolbar">
                <div className="al-toolbar-left">
                    <span className="al-lecture-count">{filteredData.length} lecture{filteredData.length !== 1 ? 's' : ''}</span>
                    <select className="al-sort" value={selectedOption} onChange={handleOptionChange}>
                        <option value="option1">Oldest first</option>
                        <option value="option2">Newest first</option>
                    </select>
                </div>
                <div className="al-search-wrapper">
                    <span className="al-search-icon">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                        </svg>
                    </span>
                    <input
                        type="text"
                        className="al-search"
                        placeholder="Search in Sahi Bukhari..."
                        value={search}
                        onChange={handleSearchChange}
                    />
                </div>
            </div>

            {/* Table header */}
            <div className="al-list-header">
                <span>#</span>
                <span>Title</span>
                <span className="al-header-parts">Parts</span>
                <span></span>
            </div>

            {/* Lecture rows */}
            <div className="al-list" style={{ marginBottom: audioUrl ? '100px' : '0' }}>
                {filteredData.length === 0 && <div className="al-empty">No lectures found.</div>}
                {filteredData.map((cur, index) => {
                    const cleanName = removeSpecificPhrase(cur.name, "By: Aalima Nikhat Haider Aapa");
                    const isActive = currentLectureName === cleanName;
                    return (
                        <div key={cur['_id']} className={`al-row ${isActive ? 'al-row-active' : ''}`}>
                            <span className="al-col-num">{index + 1}</span>
                            <div className="al-col-title-group">
                                <span className="al-col-title" title={cleanName}>{cleanName}</span>
                                {cur.date && <span className="al-col-date">{cur.date}</span>}
                            </div>
                            <div className="al-col-parts">
                                {cur.lectures.map((i, r) => (
                                    <button key={r} className={`al-play-chip ${activeLectureUrl === i ? 'al-play-chip-active' : ''}`} onClick={() => handleLinkClick(i, cleanName, i, cur.lectures, r)}>
                                        <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21"/></svg>
                                        {r + 1}
                                    </button>
                                ))}
                            </div>
                            <span className="al-col-actions"></span>
                        </div>
                    );
                })}
            </div>

            {audioUrl && (
                <AudioPlayer
                    src={audioUrl}
                    isLoading={!audioUrlload}
                    title={currentLectureName}
                    subtitle="Sahi Bukhari Class"
                    hasPrev={currentPartIndex > 0}
                    hasNext={currentPartIndex < currentParts.length - 1}
                    onPrev={() => {
                        if (currentPartIndex > 0) {
                            const prevUrl = currentParts[currentPartIndex - 1];
                            handleLinkClick(prevUrl, currentLectureName, prevUrl, currentParts, currentPartIndex - 1);
                        }
                    }}
                    onNext={() => {
                        if (currentPartIndex < currentParts.length - 1) {
                            const nextUrl = currentParts[currentPartIndex + 1];
                            handleLinkClick(nextUrl, currentLectureName, nextUrl, currentParts, currentPartIndex + 1);
                        }
                    }}
                />
            )}
        </div>
    );
};

export default Card;
